export const ARTICLE_SUBSCRIPTION_HEADLINE = '[data-subscription-headline]';

const ArticleSubscription = () => {
  /**
   * Text, kterým bude nahrazen headline předplatného.
   */
  const rewriteSourceDiv: HTMLDivElement | null = document.querySelector(
    '[data-subscription-headline-rewrite]'
  );

  /**
   * Nahrazení headline předplatného.
   * (TPL: /default/artobj/subscription-headline-rewrite.twig)
   */
  if (rewriteSourceDiv) {
    const { subscriptionHeadlineRewrite } = rewriteSourceDiv.dataset;

    if (subscriptionHeadlineRewrite) {
      const headline = document.querySelector<HTMLElement>(`${ARTICLE_SUBSCRIPTION_HEADLINE}`);

      if (headline) headline.innerHTML = subscriptionHeadlineRewrite;
    }
  }
};

export default ArticleSubscription;
